import { Injectable } from '@angular/core';
import { GenesysCloudPlatformApiService } from 'common/store/genesys-cloud/common/services/genesys-cloud-platform-api.service';
import { Observable } from 'rxjs';
import { ConversationApiBase } from '../../common/services/conversation-api-base.service';
import { MessageData } from '../models/message-data.model';
import { MediaState } from '../models/message-media-state.enum';

export interface MediaUploadResponse {
  correlationId: string;
  files: string[];
}

@Injectable({
  providedIn: 'root'
})
export class MessageConversationMediaApiService extends ConversationApiBase {
  constructor(readonly api: GenesysCloudPlatformApiService) {
    super(api, 'messages');
  }

  getMediaUploadData$(conversationId: string, communicationId: string): Observable<{ id: string, uploadUrl: string }> {
    const path = `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/communications/${communicationId}/messages/media`;
    return this.api.post$(path, {});
  }

  checkMediaStatus$(conversationId: string, communicationId: string, mediaId: string): Observable<{ status: MediaState }> {
    const path = `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/communications/${communicationId}/messages/media/${mediaId}`;
    return this.api.get$(path);
  }

  sendMediaMessage$(conversationId: string, communicationId: string, mediaIds: string[]): Observable<MessageData> {
    const path = `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/communications/${communicationId}/messages`;
    const body = {
      mediaIds
    };

    return this.api.post$(path, body);
  }
}
